import WhatsLogo from "../../../../../assets/whatsapp-logo.svg"
import {WhatsappButton, WhatsappForm} from "./styles";

interface WhatsappBtnProps {
  text?: string;
  url?: string;
}

const DEFAULT_WHATSAPP_URL =
  "https://wa.me/5511981669461?text=Ol%C3%A1!%20Gostaria%20de%20resolver%20minhas%20pend%C3%AAncias%20com%20a%20Fix%20it.";

const WhatsappBtn: React.FC<WhatsappBtnProps> = ({
  text = "SAF Fix It",
  url = DEFAULT_WHATSAPP_URL,
}) => {
  return (
    <WhatsappForm href={url} target="_blank" rel="noopener noreferrer">
      <WhatsappButton type="button">
        <img src={WhatsLogo} alt="Logo Whatsapp" />
        {text}
      </WhatsappButton>
    </WhatsappForm>
  );
};

export default WhatsappBtn;